module.exports = __webpack_public_path__ + "static/media/store_red_icon.6414056b.svg";